export default function metadataMapper(metadata, params) {
  if (!metadata) {
    return {};
  }

  switch (metadata.type) {
    case 'search_by_image':
      return { searchbyimage: true };
    case 'more_like_this':
      return { morelikethis: params.assetid };
    case 'curated_set':
      // Rename the `curatedset` redux search param to `curatedsetid` so that we don't need this mapping.
      return { curatedset: params.curatedsetid };
    default:
      return {};
  }
}
